export default "__VITE_ASSET__MGFJZpjd__"